<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill_merge`]" width="1em" height="1em" v-bind="$attrs"><path d="M5.70828 2.30078C6.08783 2.30078 6.27805 2.30023 6.43778 2.31738C7.84093 2.46823 8.94918 3.57728 9.09989 4.98047C9.117 5.14009 9.11746 5.32983 9.11746 5.70899C9.11746 6.08853 9.11704 6.27876 9.09989 6.43848C9.07285 6.68997 9.31128 6.9274 9.56278 6.90039C9.7224 6.88327 9.91215 6.88379 10.2913 6.88379C10.6708 6.88379 10.8611 6.88324 11.0208 6.90039C12.424 7.05116 13.5322 8.16023 13.6829 9.56348C13.7 9.72312 13.7005 9.91281 13.7005 10.292C13.7005 10.6715 13.7 10.8618 13.6829 11.0215C13.5321 12.4246 12.4239 13.5328 11.0208 13.6836C10.8611 13.7008 10.6708 13.7012 10.2913 13.7012C9.91211 13.7012 9.72241 13.7007 9.56278 13.6836C8.15952 13.5329 7.05046 12.4247 6.89969 11.0215C6.88254 10.8618 6.88309 10.6715 6.88309 10.292C6.88309 9.91286 6.88257 9.7231 6.89969 9.56348C6.9267 9.31198 6.68927 9.07355 6.43778 9.10059C6.27805 9.11774 6.08783 9.11817 5.70828 9.11817C5.32913 9.11817 5.13939 9.1177 4.97977 9.10059C3.57658 8.94988 2.46753 7.84163 2.31668 6.43848C2.29953 6.27876 2.30008 6.08853 2.30008 5.70899C2.30008 5.32985 2.29958 5.14009 2.31668 4.98047C2.4674 3.57718 3.57648 2.4681 4.97977 2.31738C5.13939 2.30028 5.32915 2.30078 5.70828 2.30078Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillMerge',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
